import type { GenericBlock } from "store/slices/apisV2/control-flow/types";

export const getIconPathFromBlock = (_block: GenericBlock) => {
  return "";
};
